module.exports = __webpack_public_path__ + "745b6309c7169b2ce13e9e83b8f7bdcb.png";